import { log, logError } from '../webUtils'

const instances = (state = [], action) => {
  switch (action.type) {
    case 'PUSH_PLAYLIST_STATE':
      if (typeof action.state.instances == 'undefined') {
        // throw new Error ('Undefined state.dongles from server.')
        return state;
      }
      else
        return action.state.instances;
    case 'PUSH_SESSION_LIST':
      if (typeof action.list == 'undefined') {
        throw new Error('Undefined list from server.')
      }
      else
        return action.list;
    case 'SET_PERSISTANT_STATE_FROM_SERVER':
      if (typeof action.state.instances == 'undefined') {
        log('Undefined state.instances from server.')
        return state;
      }
      else
        return action.state.instances;
    case 'SET_STATE_FROM_DATABASE':
      if (typeof action.state.instances === 'undefined') {
        // log ('Undefined "state.instances" from server.')
        return state;
      }
      else
        return action.state.instances;
    default:
      return state
  }
}

export default instances
